module.exports = __webpack_public_path__ + "static/media/icon-carton-boxes.0046d698.png";